import { AuthenticationService, CookieService, CookieUtil } from 'psd-common';
import { environment } from '../../../../environments/environment';

export abstract class CentralLoginAccountSettingsComponent {

  constructor(public cookieService: CookieService,
              public authenticationService: AuthenticationService) {}

  abstract getCurrentUser();

  checkCookiesAndSetUser() {
    if (this.cookieService.getCentralCookie('central_access_token', environment.production) == null ||
      this.cookieService.getCentralCookie('central_access_token', environment.production) == '') {
      this.authenticationService.refreshCentralAccessToken(localStorage.getItem('userEmail'),
        this.cookieService.getCentralCookie('central_refresh_token', environment.production), null).subscribe(result => {
        CookieUtil.setCentralCookies(result.access_token, result.refresh_token, environment.production, result.expires_in);
        this.getCurrentUser();
      });
    } else {
      this.getCurrentUser();
    }
  }

}